import { CardMedia, Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import './Service.css';

const Service = (props) => {
    const { name, img, describe } = props.service;
    return (
        <Grid item xs={12} md={4}>
            <Box id="card">
                <Box id="card-top" className='image-hover'>
                    <CardMedia
                        sx={{ pt: 4, pb: 1 }}
                        component="img"
                        style={{ width: 'auto', height: '30%', margin: '0 auto', transform: 'skewY(-3deg)' }}
                        image={img}
                        alt="green iguana"
                    />
                    <Typography sx={{ pb: 1, textAlign: 'center', py: 2, color: '#000D83', transform: 'skewY(-3deg)' }} variant="h6" id="card-name" component="div">
                        {name}
                    </Typography>
                </Box>
                <Box id="details-align">
                    <Typography sx={{ textAlign: 'left', mx: 3, color: '#5B5B5B', pb: 4, transform: 'skewY(-3deg)' }} variant="body3" id="card-details" component="div">
                        {describe}
                    </Typography>
                </Box>
            </Box>
        </Grid>
    );
};

export default Service;